import { Modal, List, Typography, Card, Spin } from 'antd';
import DOMPurify from 'dompurify';
import VirtualList from 'rc-virtual-list';
import { asyncNoticeInit, asyncMessageReadAll } from "@/app/reducers/noticeSlice";
import { useI18n } from '@/i18n';
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { ClearOutlined } from '@ant-design/icons';
import useNoticeNavigate from '@/hooks/useNoticeNavigate';
import './index.less';

export default function Index(props) {
  const { open, toggleNoticeOpen } = props;
  const dispatch = useDispatch();
  const noticeNavigate = useNoticeNavigate();
  const { loading, list, total } = useSelector((state) => state.notice, shallowEqual);
  const $t = useI18n('component.notice.language');
  const [pages, setPages] = useState({ page_size: 10, page: 1 });
  const loadingRef = useRef(false);
  useEffect(() => {
    loadingRef.current = loading;
  }, [loading]);

  useEffect(() => {
    const fetchData = async () => {
      if (!open) return;
      dispatch(asyncNoticeInit({ page: pages.page, page_size: pages.page_size }));
    };

    fetchData();
  }, [open, pages, dispatch]);


  const onScroll = (e) => {
    const { scrollHeight, scrollTop, clientHeight } = e.currentTarget;
    const isBottom = scrollHeight - scrollTop <= clientHeight + 10;

    if (isBottom && !loading && list.length > 0 && list.length < total) {
      setPages(prev => ({ ...prev, page: prev.page + 1 }));
    }
  };

  const readAll = async () => {
    if (list.length) {
      dispatch(asyncMessageReadAll());
      //   const { data: { code } } = await messageReadAll();
      //   if (+code === 0) {
      //     setPages(prev => ({ ...prev, page: 1 }));
      //   }
      // }
    }
  };

  const viewNotice = async (item) => {
    // if (!item.is_read) {
    //   const { data: { code } } = await messageRead({ id: item.id });
    //   if (+code === 0) {
    //     setPages(prev => ({ ...prev, page: 1 }));
    //   }
    // }
    noticeNavigate(item);
    toggleNoticeOpen();
  };

  return (
    <Modal open={open} footer={null} width={800} title={$t('Message center')} onCancel={toggleNoticeOpen} getContainer={false} destroyOnHidden>
      <Card title={$t('Message')} extra={<Typography.Link type='danger' onClick={readAll}>  <ClearOutlined style={{ marginRight: 4 }} />  {$t('All set to read')}</Typography.Link>}>
        <List>
          <VirtualList data={list} height={400} itemHeight={47} itemKey="id" onScroll={onScroll}>
            {(item) => (
              <List.Item key={item.id} className='notice-item'>
                <List.Item.Meta
                  title={
                    <div className='flex-space-between'>
                      <div>
                        <span className={!item.is_read ? 'circle' : 'circle_empty'}></span>
                        <span>{item.title}</span>
                      </div>
                      <span style={{ fontSize: '14px', color: '#999', fontWeight: 'initial' }}>{item.create_time}</span>
                    </div>
                  }
                  description={
                    <div className='flex-space-between'>
                      <div style={{ paddingLeft: 20 }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.content) }}></div>
                      {!item.params?.approved && <Typography.Link type='danger' onClick={() => viewNotice(item)}>{$t('View')}</Typography.Link>}
                    </div>
                  }
                />
              </List.Item>
            )}
          </VirtualList>
          {loading && <div style={{ textAlign: 'center', padding: '10px 0' }}><Spin size="small" /></div>}
          {!loading && list.length >= total && list.length > 0 && (
            <div style={{ textAlign: 'center', color: '#999', padding: '10px 0' }}>{$t('No more')}</div>
          )}
        </List>
      </Card>
    </Modal>
  );
}